import * as z from "zod/v4";

export const setJudgeMeIntegration = {
  name: "setJudgeMeIntegration" as const,
  input: z.object({
    shopDomain: z.string(),
    publicApiToken: z.string(),
    privateApiToken: z.string(),
  }),
  output: z.null(),
};

export type SetJudgeMeIntegrationInput = z.infer<
  typeof setJudgeMeIntegration.input
>;
